<template>
    <div class="wrapper" style="width: 100%; margin-top: 20px;">
        <div style="width: 25%;">
            <div style="display: flex; justify-content: end">
                <SidebarMenu
                    ref="sidebarMenu"
                    sidebarTitle="资产管理"
                    :menu-list="menuList"
                    :active-menu="activeMenu"
                    @menu-click="handleMenuClick"
                    @close-all-menu="closeAllMenu"
                />
            </div>
        </div>
        <div style="width: 2%;"></div>
        <div style="width: 78%; padding: 0 2rem 0 0;">
            <div v-if="active !== 'mapTagManagement'">
                <div class="content-header">
                    <h1 class="content-title">{{ getFirstLevelMenuName() }} > {{ currentMenuTitle }}</h1>
                    <p class="content-subtitle">{{ currentMenuDesc }}</p>
                </div>
                <div class="weather-content">
                    <RainWellIndex v-if="active === 'rain-well'" @show-rain-well-add="showRainWellAdd"  @show-rain-well-detail="showRainWellDetail" @show-rain-well-edit="showRainWellEdit"/>
                    <RainWellAddIndex v-if="active === 'rain-well-add'" @show-rain-well-index="showRainWellIndex" />
                    <RainWellEditIndex v-if="active === 'rain-well-edit'"  @show-rain-well-index="showRainWellIndex" :id="id"/>

                    <SewageWellIndex v-if="active === 'sewage-well'"  @show-sewage-well-add="showSewageWellAdd"  @show-sewage-well-detail="showSewageWellDetail" @show-sewage-well-edit="showSewageWellEdit"/>
                    <SewageWellAddIndex v-if="active === 'sewage-well-add'" @show-sewage-well-index="showSewageWellIndex" />
                    <SewageWellEditIndex v-if="active === 'sewage-well-edit'"  @show-sewage-well-index="showSewageWellIndex" :id="id"/>

                    <RainIndex v-if="active === 'rain'" @show-rain-add="showRainAdd"  @show-rain-detail="showRainDetail" @show-rain-edit="showRainEdit"/>
                    <RainAddIndex v-if="active === 'rain-add'" @show-rain-index="showRainIndex"/>
                    <RainEditIndex v-if="active === 'rain-edit'" @show-rain-index="showRainIndex" :id="id"/>

                    <SewageIndex v-if="active === 'sewage'" @show-sewage-add="showSewageAdd"  @show-sewage-detail="showSewageDetail" @show-sewage-edit="showSewageEdit"/>
                    <SewageAddIndex v-if="active === 'sewage-add'" @show-sewage-index="showSewageIndex" />
                    <SewageEditIndex v-if="active === 'sewage-edit'"  @show-sewage-index="showSewageIndex" :id="id"/>

                    <PumpIndex  v-if="active === 'pump'" @show-pump-add="showPumpAdd"  @show-pump-detail="showPumpDetail" @show-pump-edit="showPumpEdit"/>
                    <PumpAddIndex v-if="active === 'pump-add'" @show-pump-index="showPumpIndex" />
                    <PumpEditIndex v-if="active === 'pump-edit'"  @show-pump-index="showPumpIndex" :id="id"/>
                </div>
            </div>
            <router-view v-else></router-view>
        </div>
    </div>
</template>

<script>
import SidebarMenu from "@/components/water-affairs-style/sidebarMenuList.vue";

import RainWellIndex from "./rain-well/index.vue";
import RainWellAddIndex from './rain-well/add.vue'
import RainWellEditIndex from './rain-well/edit.vue'

import SewageWellIndex from "./sewage-well/index.vue";
import SewageWellAddIndex from './sewage-well/add.vue'
import SewageWellEditIndex from './sewage-well/edit.vue'

import RainIndex from "./rain/index.vue";
import RainAddIndex from './rain/add.vue'
import RainEditIndex from './rain/edit.vue'

import SewageIndex from "./sewage/index.vue";
import SewageAddIndex from './sewage/add.vue'
import SewageEditIndex from './sewage/edit.vue'

import PumpIndex from "./pump/index.vue";
import PumpAddIndex from './pump/add.vue'
import PumpEditIndex from './pump/edit.vue'
export default {
    components: {
        SidebarMenu,
        RainWellIndex,RainWellAddIndex,RainWellEditIndex,
        SewageWellIndex,SewageWellAddIndex,SewageWellEditIndex,
        RainIndex,RainAddIndex,RainEditIndex,
        SewageIndex,SewageAddIndex,SewageEditIndex,
        PumpIndex,PumpAddIndex,PumpEditIndex,
    },
    computed: {
        currentMenuTitle() {
            let menu = this.menuList.find(m => m.key === this.activeMenu);
            if (menu) return menu.title;

            for (const parent of this.menuList) {
                const child = parent.children?.find(c => c.key === this.activeMenu);
                if (child) return child.title;
            }
            return this.menuList[0]?.children[0]?.title || '雨水井';
        },
        currentMenuDesc() {
            let menu = this.menuList.find(m => m.key === this.activeMenu);
            if (menu) return menu.desc;

            for (const parent of this.menuList) {
                const child = parent.children?.find(c => c.key === this.activeMenu);
                if (child) return child.desc;
            }
            return this.menuList[0]?.children[0]?.desc || '';
        }
    },
    data() {
        return {
            active: "rain-well",
            activeMenu: 'rain-well',
            id: '',
            menuList:[
                {
                    key: 'pipe-network-asset',
                    title: '管网资产',
                    icon: '',
                    iconimage:'/pipe/pipe.png',
                    iconActiveImg:'/pipe/pipe-active.png',
                    desc: '管理各类管网及检查井资产信息',
                    children: [
                        { key: 'rain-well', title: '雨水井', icon: '', iconimage:'/pipe/rainWell.png', iconActiveImg:'/pipe/rainWell-active.png', desc: '雨水管网配套检查井管理' },
                        { key: 'sewage-well', title: '污水井', icon: '', iconimage:'/pipe/sewageWell.png', iconActiveImg:'/pipe/sewageWell-active.png',desc: '污水管网配套检查井管理' },
                        { key: 'rain', title: '雨水管网', icon: '', iconimage:'/pipe/rain.png', iconActiveImg:'/pipe/rain-active.png',desc: '雨水输送管网线路及属性管理' },
                        { key: 'sewage', title: '污水管网', icon: '', iconimage:'/pipe/sewage.png', iconActiveImg:'/pipe/sewage-active.png',desc: '污水输送管网线路及属性管理' }
                    ]
                },
                {
                    key: 'facility-asset',
                    title: '设施资产',
                    icon: '',
                    iconimage:'/pipe/asset.png',
                    iconActiveImg:'/pipe/asset-active.png',
                    desc: '管理排水系统核心功能性设施',
                    children: [
                        { key: 'pump', title: '泵站', icon: '⚙️', desc: '排水提升泵站运行与维护管理' },
                        { key: 'grille-facility', title: '格栅', icon: '⚙️', desc: '污水杂质拦截格栅设备管理' },
                        { key: 'gate-valve', title: '闸门', icon: '⚙️', desc: '管网流量控制闸门设备管理' },
                        { key: 'hoisting-equipment', title: '吊车', icon: '⚙️', desc: '管网维护用起重吊车管理' }
                    ]
                },
                {
                    key: 'device-asset',
                    title: '设备资产',
                    icon: '',
                    iconimage:'/pipe/device.png',
                    iconActiveImg:'/pipe/device-active.png',
                    desc: '管理排水系统监测与感知设备',
                    children: [
                        { key: 'liquid-level-meter', title: '液位计', icon: '⚙️', desc: '井/管网内液位监测设备管理' },
                        { key: 'flow-meter', title: '流量计', icon: '⚙️', desc: '管网流量计量设备管理' },
                        { key: 'surveillance-camera', title: '监控', icon: '⚙️', desc: '管网/设施现场监控摄像头管理' },
                        { key: 'surveillance-camera', title: '智慧截流井', icon: '⚙️', desc: '智慧截流井管理' },
                        { key: 'surveillance-camera', title: '水质检测', icon: '⚙️', desc: '水质检测管理' }
                    ]
                },
                {
                    key: 'drainage-user',
                    title: '排水户管理',
                    icon: '',
                    iconimage:'/pipe/sewerage.png',
                    iconActiveImg:'/pipe/sewerage-active.png',
                    desc: '按类别管理各类排水用户信息',
                    children: [
                        { key: 'key-type1-user', title: '重点一类排水户', icon: '⚙️', desc: '高风险/重点监管一类排水用户' },
                        { key: 'key-type2-user', title: '重点二类排水户', icon: '⚙️', desc: '中风险/重点监管二类排水用户' },
                        { key: 'general-drainage-user', title: '一般排水户', icon: '⚙️', desc: '普通民用/低风险排水用户' },
                        { key: 'industrial-drainage-user', title: '工业排水户', icon: '⚙️', desc: '工业生产废水排放用户' },
                        { key: 'construction-drainage-user', title: '建筑排水户', icon: '⚙️', desc: '建筑施工/工地排水用户' },
                        { key: 'catering-drainage-user', title: '餐饮排水户', icon: '⚙️', desc: '餐饮行业废水排放用户' },
                        { key: 'medical-drainage-user', title: '医疗排水户', icon: '⚙️', desc: '医疗机构污水排放用户' }
                    ]
                }
            ]
        };
    },
    methods: {
        showRainWellIndex(){
            this.active = 'rain-well';
        },
        showRainWellAdd(){
            this.active = 'rain-well-add';
        },
        showRainWellDetail(id){
            this.active = 'rain-well-detail';this.id = id;
        },
        showRainWellEdit(id){
            this.active = 'rain-well-edit';this.id = id;
        },
        showSewageWellIndex(){
            this.active = 'sewage-well';
        },
        showSewageWellAdd(){
            this.active = 'sewage-well-add';
        },
        showSewageWellDetail(id){
            this.active = 'sewage-well-detail';this.id = id;
        },
        showSewageWellEdit(id){
            this.active = 'sewage-well-edit';this.id = id;
        },
        showRainIndex(){
            this.active = 'rain';
        },
        showRainAdd(){
            this.active = 'rain-add';
        },
        showRainDetail(id){
            this.active = 'rain-detail';this.id = id;
        },
        showRainEdit(id){
            this.active = 'rain-edit';this.id = id;
        },
        showSewageIndex(){
            this.active = 'sewage';
        },
        showSewageAdd(){
            this.active = 'sewage-add';
        },
        showSewageDetail(id){
            this.active = 'sewage-detail';this.id = id;
        },
        showSewageEdit(id){
            this.active = 'sewage-edit';this.id = id;
        },
        showPumpIndex(){
            this.active = 'pump';
        },
        showPumpAdd(){
            this.active = 'pump-add';
        },
        showPumpDetail(id){
            this.active = 'pump-detail';this.id = id;
        },
        showPumpEdit(id){
            this.active = 'pump-edit';this.id = id;
        },
        getFirstLevelMenuName() {
            for (const parent of this.menuList) {
                const hasChild = parent.children?.some(c => c.key === this.activeMenu);
                if (hasChild) return parent.title;
            }
            return this.menuList[0]?.title || '管网资产';
        },
        handleMenuClick(menuKey) {
            const parentMenu = this.menuList.find(m => m.key === menuKey && m.children);
            if (parentMenu) {
                this.activeMenu = menuKey;
                this.active = menuKey;
            } else {
                this.activeMenu = menuKey;
                this.active = menuKey;
            }
        },
        closeAllMenu() {
            console.log("Closing all menus");
            this.expandedMenus = this.expandedMenus.map(() => false);
            this.$emit('close-all-menu');
        }
    }
};
</script>


<style lang="less" scoped>
.wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .content-title {
        font-size: 1.8rem;
        font-weight: bold;
        background: linear-gradient(135deg, #fff, #00ff96);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 0.5rem;
    }

    .content-subtitle {
        color: #64748b;
        font-size: 0.95rem;
    }

    .weather-content {
        background: rgba(20, 35, 70, 0.5);
        border: 1px solid rgba(0, 255, 150, 0.2);
        border-radius: 16px;
        padding: 2rem;
        margin-bottom: 1.5rem;
    }
}
</style>